export type Role =
    | 'sdzReadOnly'
    | 'sdzUser'
    | 'sdzAdmin'
    | 'owner'
    | 'viewer'
    | 'sdzGovernance';

export type Feature =
    | 'dictionary-editor'
    | 'developer-docs'
    | 'dashboard'
    | 'edge-definitions'
    | 'lifegraph-explorer'
    | 'tql-editor'
    | 'smart-contracts'
    | 'job-manager'
    | 'consent-contracts'
    | 'wallets-and-groups';

export interface RequiredRoles {
    dictionary: Role[];
    lifegraph: Role[];
    tqlEditor: Role[];
    consentContract: Role[];
    lifegraphEditor: Role[];
    smartContract: Role[];
    verifications: Role[];
    profile: Role[];
    jobManager: Role[];
    walletsAndGroups: Role[];
    documentation: Role[];
    receipts: Role[];
    askBlast: Role[];
    systemMessages: Role[];
    metadataSearch: Role[];
    helpDesk: Role[];
    glossaryMetadata: Role[];
    pipelines: Role[];
}

export const requiredRoles: RequiredRoles = {
    tqlEditor: ['sdzReadOnly', 'sdzUser'],
    lifegraph: ['sdzReadOnly', 'sdzUser'],
    lifegraphEditor: ['sdzReadOnly', 'sdzUser'],
    dictionary: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    consentContract: ['sdzReadOnly', 'sdzUser'],
    smartContract: ['sdzReadOnly', 'sdzUser'],
    verifications: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    profile: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    jobManager: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    walletsAndGroups: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    documentation: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    receipts: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    askBlast: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    systemMessages: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    metadataSearch: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    helpDesk: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    glossaryMetadata: ['sdzReadOnly', 'sdzUser', 'sdzAdmin'],
    pipelines: ['sdzReadOnly', 'sdzAdmin'],
};
